/** markdown-it 视频：@[video](url) → <video> */

const VIDEO_RE = /@\[video\]\(\s*<?([^>\s)]+)>?\s*\)/gi;

function escapeHtml(str) {
  return String(str || '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function buildVideoHtml(url) {
  const src = escapeHtml(url);
  return `<video class="doc-video" src="${src}" controls style="max-width:100%;display:block;margin:0.75em 0;"></video>`;
}

module.exports = function markdownItDocVideo(md) {
  md.core.ruler.before('inline', 'doc_video_preprocess', (state) => {
    state.src = state.src.replace(VIDEO_RE, (match, url) => buildVideoHtml(url));
  });
};
